export const frontWebRoutes = [
    {
        path: '/courseBrief/:id',
        name: 'courseBriefDetail',
        component: () => import('@/views/frontWeb/course/index'),
    },
    {
        // 问答页面
        path: '/qa',
        name: 'qaMain',
        component: () => import('@/views/frontWeb/qa/list/index')
    },
    {
        // 问答页面
        path: '/qaDetail',
        name: 'qaDetail',
        component: () => import('@/views/frontWeb/qa/detail/detail.vue')
    },
    {
      // 资讯页面
      path: '/news/index',
      name: 'NewsIndex',
      component: () => import('@/views/frontWeb/news/index.vue')
    },
    // 资讯列表页
    {
      path: '/news/list',
      name: 'NewsList',
      component: () => import('@/views/frontWeb/news/list.vue'),
    },
    // 资讯 -- 计算器页
    {
      path: '/news/calculator',
      name: 'NewsCalculator',
      component: () => import('@/views/frontWeb/news/calculator/index.vue'),
      meta: {
        documentTitle: '税务计算器',
      }
    },
   // 资讯详情页
   {
     path: '/news/:id',
     name: 'NewsDetail',
     component: () => import('@/views/frontWeb/news/detail.vue'),
   },
  {
    path: '/advDetail',
    name: 'AdvDetail',
    component: () => import('@/views/advDetail/index.vue'),
  },
]
